import { FilterMenuConfig } from '../../types/filter.type';

export const COUNTRY_FILTERS: FilterMenuConfig = {
  sortMode: 'alphabetic',
  filters: [
    {
      type: 'checkbox',
      data: [],
    },
  ],
};
